import { SvgIcon, SvgIconProps } from "@mui/material";

const LillyLogo = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="100 0 500 400">
    <g transform="translate(-2063.416,-292.3542)" id="layer1">
      <path
        d="M 2387.6643,463.3717 C 2397.2498,463.3717 2404.9711,471.15993 2404.9711,480.74545 C 2404.9711,490.331 2397.2498,498.11913 2387.6643,498.11913 C 2378.0121,498.11913 2370.2908,490.331 2370.2908,480.74545 C 2370.2908,471.15993 2378.0121,463.3717 2387.6643,463.3717 L 2387.6643,463.3717 M 2780.9357,522.54886 C 2753.577,549.77434 2668.3731,624.52797 2645.8075,687.4994 L 2617.916,680.31031 C 2627.0352,654.21639 2654.5272,613.67775 2685.1481,582.3917 C 2678.6238,584.85464 2671.834,585.78655 2666.3756,585.78655 C 2658.1215,585.78655 2651.6648,583.25708 2647.8042,578.59745 C 2645.0083,575.2025 2643.6104,570.80922 2643.6104,565.55045 C 2643.6104,564.4188 2643.6769,563.28724 2643.8768,561.95594 C 2616.9177,578.39781 2595.283,585.78655 2574.1154,585.78655 C 2557.607,585.78655 2543.6944,578.59745 2537.3045,565.94985 C 2510.6119,579.26311 2484.9832,585.78655 2463.5492,585.78655 C 2443.6464,585.78655 2427.5375,577.86527 2420.2149,563.48689 C 2393.1893,578.66406 2370.2243,585.78655 2351.9848,585.78655 C 2341.4011,585.78655 2333.0802,582.8577 2327.6883,577.33268 C 2323.7611,573.27216 2321.6971,567.81375 2321.4307,561.48995 C 2304.1237,572.87276 2278.829,585.78655 2252.8682,585.78655 C 2226.3747,585.78655 2208.5349,576.66703 2194.7556,567.6141 C 2172.7222,579.79562 2148.4923,585.78655 2122.9312,585.78655 C 2103.5602,585.78655 2072.2743,577.73216 2072.2743,549.97406 C 2072.2743,527.54129 2095.7058,512.3643 2126.9917,512.3643 C 2153.551,512.3643 2179.1797,523.54738 2195.2886,535.19639 C 2210.5324,523.08139 2226.5745,506.0405 2245.4791,482.01015 C 2241.2853,482.2764 2237.2248,482.40954 2233.231,482.40954 C 2197.0195,482.40954 2166.8649,471.69244 2150.3565,453.05389 C 2141.4361,442.93585 2137.2425,431.0871 2137.2425,418.37307 C 2137.2425,368.04916 2200.8136,329.04148 2256.3959,323.25028 C 2260.0567,331.57095 2263.3854,338.02788 2266.7798,345.61647 C 2211.797,352.00671 2166.0657,384.55754 2166.0657,416.30952 C 2166.0657,437.21127 2189.5636,458.17954 2239.3545,458.17954 C 2247.8752,458.17954 2256.4625,457.38075 2264.9166,456.18258 C 2308.916,395.47437 2376.2812,301.21688 2434.3273,301.21688 C 2451.4343,301.21688 2460.4204,311.6678 2460.4204,325.58002 C 2460.4204,354.33651 2435.7253,385.22319 2419.6821,401.33218 C 2394.3874,426.69381 2348.6561,464.50325 2284.8194,477.01764 C 2259.9902,511.56553 2239.6209,534.46423 2219.1853,551.03911 C 2231.5667,557.69569 2243.1495,561.75621 2256.9955,561.75621 C 2291.3427,561.75621 2324.6928,530.33701 2350.7201,503.64415 L 2351.6518,502.77877 L 2371.9543,518.6214 L 2371.0226,519.75305 C 2359.5062,532.93309 2348.856,546.91208 2348.856,554.70024 C 2348.856,560.62465 2353.9147,561.82282 2358.175,561.82282 C 2371.3558,561.82282 2391.6583,553.30232 2415.4883,538.59125 L 2415.4883,538.39159 C 2418.1511,479.48068 2498.6292,389.21718 2547.4895,389.21718 C 2561.2678,389.21718 2569.19,396.07341 2569.19,408.12189 C 2569.19,437.74378 2518.2001,501.1146 2444.0451,549.57469 L 2444.0451,549.6412 C 2447.8402,557.89544 2456.6928,561.88933 2471.6702,561.88933 C 2483.3865,561.88933 2506.285,556.69727 2533.5104,542.45201 C 2536.6392,511.89829 2553.9462,479.08128 2575.913,455.71658 C 2597.9466,432.28528 2622.6418,417.04168 2644.0101,417.04168 C 2657.1898,417.04168 2664.9776,424.29748 2664.9776,435.68023 C 2664.9776,461.44127 2635.0231,505.5745 2562.8656,551.70476 C 2566.0612,557.89544 2572.2512,561.82282 2581.9035,561.82282 C 2603.4049,561.82282 2641.2142,538.92412 2670.7027,510.70004 L 2691.8711,527.14189 C 2682.8174,538.12533 2673.6982,550.17373 2673.9646,557.09667 C 2674.0313,559.35986 2675.5624,560.89091 2679.1566,560.89091 C 2700.8571,560.89091 2735.0721,532.20091 2760.6998,506.83927 L 2780.9357,522.54886 L 2780.9357,522.54886 M 2306.9861,445.59862 C 2338.805,435.34745 2369.0252,414.04631 2391.5915,391.74665 C 2412.3605,371.11114 2429.0677,346.61488 2429.0677,334.49989 C 2429.0677,331.70409 2427.0713,330.03992 2424.542,330.03992 C 2414.9563,330.03992 2396.6503,342.88717 2372.0209,367.51665 C 2352.8499,386.68761 2330.5507,412.91465 2306.9861,445.59862 L 2306.9861,445.59862 M 2170.9254,550.83936 C 2159.2093,542.65175 2141.104,535.59586 2124.8612,535.59586 C 2109.1519,535.59586 2099.1002,541.71985 2099.1002,549.57469 C 2099.1002,558.49456 2111.3483,562.35533 2124.9942,562.35533 C 2141.5029,562.35533 2156.5468,557.89544 2170.9254,550.83936 L 2170.9254,550.83936 M 2443.6464,521.35061 C 2488.0455,487.80135 2534.7085,438.94194 2539.7007,418.9056 C 2539.8338,418.23995 2540.0336,417.57419 2539.9671,416.97515 C 2539.9005,415.64387 2539.1687,414.44568 2537.5044,414.44568 C 2523.4587,414.44568 2458.3574,474.48817 2443.6464,521.35061 L 2443.6464,521.35061 L 2443.6464,521.35061 M 2561.4011,526.67599 C 2565.5282,523.74705 2569.9884,520.35218 2574.1154,517.09045 C 2606.0009,491.59567 2630.3641,463.63795 2635.223,448.12809 C 2635.3561,447.66209 2635.7558,446.19767 2635.7558,445.06611 C 2635.7558,443.46837 2635.0231,442.33681 2633.5586,442.33681 C 2618.9142,442.33681 2571.9191,489.13273 2560.536,527.00876 L 2560.536,527.14189 L 2561.4011,526.67599 L 2561.4011,526.67599 z "
        style={{
          fill:
            props.style && props.style.color ? props.style.color : "#D52B1E",
        }}
        id="path29682"
      />
    </g>
    <defs id="defs1945">
      <clipPath id="clp47">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path10279"
        />
      </clipPath>
      <clipPath id="clp46">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10273"
        />
      </clipPath>
      <clipPath id="clp45">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10267"
        />
      </clipPath>
      <clipPath id="clp44">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10261"
        />
      </clipPath>
      <clipPath id="clp52">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path10312"
        />
      </clipPath>
      <clipPath id="clp51">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10306"
        />
      </clipPath>
      <clipPath id="clp50">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10300"
        />
      </clipPath>
      <clipPath id="clp49">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10294"
        />
      </clipPath>
      <clipPath id="clp57">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path10345"
        />
      </clipPath>
      <clipPath id="clp56">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10339"
        />
      </clipPath>
      <clipPath id="clp55">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10333"
        />
      </clipPath>
      <clipPath id="clp54">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10327"
        />
      </clipPath>
      <clipPath id="clp62">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path10378"
        />
      </clipPath>
      <clipPath id="clp61">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10372"
        />
      </clipPath>
      <clipPath id="clp60">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10366"
        />
      </clipPath>
      <clipPath id="clp59">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10360"
        />
      </clipPath>
      <clipPath id="clp67">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path10411"
        />
      </clipPath>
      <clipPath id="clp66">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10405"
        />
      </clipPath>
      <clipPath id="clp65">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10399"
        />
      </clipPath>
      <clipPath id="clp64">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10393"
        />
      </clipPath>
      <clipPath id="clp72">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path10444"
        />
      </clipPath>
      <clipPath id="clp71">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10438"
        />
      </clipPath>
      <clipPath id="clp70">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10432"
        />
      </clipPath>
      <clipPath id="clp69">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10426"
        />
      </clipPath>
      <clipPath id="clp77">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path10477"
        />
      </clipPath>
      <clipPath id="clp76">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10471"
        />
      </clipPath>
      <clipPath id="clp75">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10465"
        />
      </clipPath>
      <clipPath id="clp74">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10459"
        />
      </clipPath>
      <clipPath id="clp82">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path10510"
        />
      </clipPath>
      <clipPath id="clp81">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10504"
        />
      </clipPath>
      <clipPath id="clp80">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10498"
        />
      </clipPath>
      <clipPath id="clp79">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10492"
        />
      </clipPath>
      <clipPath id="clp87">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path10543"
        />
      </clipPath>
      <clipPath id="clp86">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10537"
        />
      </clipPath>
      <clipPath id="clp85">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10531"
        />
      </clipPath>
      <clipPath id="clp84">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10525"
        />
      </clipPath>
      <clipPath id="clp92">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path10576"
        />
      </clipPath>
      <clipPath id="clp91">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10570"
        />
      </clipPath>
      <clipPath id="clp90">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10564"
        />
      </clipPath>
      <clipPath id="clp89">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10558"
        />
      </clipPath>
      <clipPath id="clp97">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path10609"
        />
      </clipPath>
      <clipPath id="clp96">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10603"
        />
      </clipPath>
      <clipPath id="clp95">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10597"
        />
      </clipPath>
      <clipPath id="clp94">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10591"
        />
      </clipPath>
      <clipPath id="clp102">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path10642"
        />
      </clipPath>
      <clipPath id="clp101">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10636"
        />
      </clipPath>
      <clipPath id="clp100">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10630"
        />
      </clipPath>
      <clipPath id="clp99">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10624"
        />
      </clipPath>
      <clipPath id="clp107">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path10675"
        />
      </clipPath>
      <clipPath id="clp106">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10669"
        />
      </clipPath>
      <clipPath id="clp105">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10663"
        />
      </clipPath>
      <clipPath id="clp104">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10657"
        />
      </clipPath>
      <clipPath id="clp112">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path10708"
        />
      </clipPath>
      <clipPath id="clp111">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10702"
        />
      </clipPath>
      <clipPath id="clp110">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10696"
        />
      </clipPath>
      <clipPath id="clp109">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10690"
        />
      </clipPath>
      <clipPath id="clp117">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path10741"
        />
      </clipPath>
      <clipPath id="clp116">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10735"
        />
      </clipPath>
      <clipPath id="clp115">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10729"
        />
      </clipPath>
      <clipPath id="clp114">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10723"
        />
      </clipPath>
      <clipPath id="clp122">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path10774"
        />
      </clipPath>
      <clipPath id="clp121">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10768"
        />
      </clipPath>
      <clipPath id="clp120">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10762"
        />
      </clipPath>
      <clipPath id="clp119">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10756"
        />
      </clipPath>
      <clipPath id="clp127">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path10807"
        />
      </clipPath>
      <clipPath id="clp126">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10801"
        />
      </clipPath>
      <clipPath id="clp125">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10795"
        />
      </clipPath>
      <clipPath id="clp124">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10789"
        />
      </clipPath>
      <clipPath id="clp132">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path10840"
        />
      </clipPath>
      <clipPath id="clp131">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10834"
        />
      </clipPath>
      <clipPath id="clp130">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10828"
        />
      </clipPath>
      <clipPath id="clp129">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10822"
        />
      </clipPath>
      <clipPath id="clp137">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path10873"
        />
      </clipPath>
      <clipPath id="clp136">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10867"
        />
      </clipPath>
      <clipPath id="clp135">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10861"
        />
      </clipPath>
      <clipPath id="clp134">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10855"
        />
      </clipPath>
      <clipPath id="clp142">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path10906"
        />
      </clipPath>
      <clipPath id="clp141">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10900"
        />
      </clipPath>
      <clipPath id="clp140">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10894"
        />
      </clipPath>
      <clipPath id="clp139">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10888"
        />
      </clipPath>
      <clipPath id="clp147">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path10939"
        />
      </clipPath>
      <clipPath id="clp146">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10933"
        />
      </clipPath>
      <clipPath id="clp145">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10927"
        />
      </clipPath>
      <clipPath id="clp144">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10921"
        />
      </clipPath>
      <clipPath id="clp152">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path10972"
        />
      </clipPath>
      <clipPath id="clp151">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10966"
        />
      </clipPath>
      <clipPath id="clp150">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10960"
        />
      </clipPath>
      <clipPath id="clp149">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10954"
        />
      </clipPath>
      <clipPath id="clp157">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11005"
        />
      </clipPath>
      <clipPath id="clp156">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path10999"
        />
      </clipPath>
      <clipPath id="clp155">
        <path
          d="M 396.11,638.75 L 477.22,638.75 L 477.22,615.05 L 396.11,615.05 L 396.11,638.75 z "
          id="path10993"
        />
      </clipPath>
      <clipPath id="clp154">
        <path
          d="M 396.39,617.03 L 477.47,617.03 L 477.47,636.78 L 396.39,636.78 L 396.39,617.03 z "
          id="path10987"
        />
      </clipPath>
      <clipPath id="clp160">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11054"
        />
      </clipPath>
      <clipPath id="clp159">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11048"
        />
      </clipPath>
      <clipPath id="clp163">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11075"
        />
      </clipPath>
      <clipPath id="clp162">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11069"
        />
      </clipPath>
      <clipPath id="clp166">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11096"
        />
      </clipPath>
      <clipPath id="clp165">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11090"
        />
      </clipPath>
      <clipPath id="clp169">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11117"
        />
      </clipPath>
      <clipPath id="clp168">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11111"
        />
      </clipPath>
      <clipPath id="clp172">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11138"
        />
      </clipPath>
      <clipPath id="clp171">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11132"
        />
      </clipPath>
      <clipPath id="clp175">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11159"
        />
      </clipPath>
      <clipPath id="clp174">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11153"
        />
      </clipPath>
      <clipPath id="clp178">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11180"
        />
      </clipPath>
      <clipPath id="clp177">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11174"
        />
      </clipPath>
      <clipPath id="clp181">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11201"
        />
      </clipPath>
      <clipPath id="clp180">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11195"
        />
      </clipPath>
      <clipPath id="clp184">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11222"
        />
      </clipPath>
      <clipPath id="clp183">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11216"
        />
      </clipPath>
      <clipPath id="clp187">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11243"
        />
      </clipPath>
      <clipPath id="clp186">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11237"
        />
      </clipPath>
      <clipPath id="clp190">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11264"
        />
      </clipPath>
      <clipPath id="clp189">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11258"
        />
      </clipPath>
      <clipPath id="clp193">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11285"
        />
      </clipPath>
      <clipPath id="clp192">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11279"
        />
      </clipPath>
      <clipPath id="clp196">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11306"
        />
      </clipPath>
      <clipPath id="clp195">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11300"
        />
      </clipPath>
      <clipPath id="clp199">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11327"
        />
      </clipPath>
      <clipPath id="clp198">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11321"
        />
      </clipPath>
      <clipPath id="clp202">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11348"
        />
      </clipPath>
      <clipPath id="clp201">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11342"
        />
      </clipPath>
      <clipPath id="clp205">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11369"
        />
      </clipPath>
      <clipPath id="clp204">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11363"
        />
      </clipPath>
      <clipPath id="clp208">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11390"
        />
      </clipPath>
      <clipPath id="clp207">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11384"
        />
      </clipPath>
      <clipPath id="clp217">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11453"
        />
      </clipPath>
      <clipPath id="clp216">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11447"
        />
      </clipPath>
      <clipPath id="clp220">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11474"
        />
      </clipPath>
      <clipPath id="clp219">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11468"
        />
      </clipPath>
      <clipPath id="clp223">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11495"
        />
      </clipPath>
      <clipPath id="clp222">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11489"
        />
      </clipPath>
      <clipPath id="clp226">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11516"
        />
      </clipPath>
      <clipPath id="clp225">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11510"
        />
      </clipPath>
      <clipPath id="clp229">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11537"
        />
      </clipPath>
      <clipPath id="clp228">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11531"
        />
      </clipPath>
      <clipPath id="clp232">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11558"
        />
      </clipPath>
      <clipPath id="clp231">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11552"
        />
      </clipPath>
      <clipPath id="clp235">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11579"
        />
      </clipPath>
      <clipPath id="clp234">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11573"
        />
      </clipPath>
      <clipPath id="clp238">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11600"
        />
      </clipPath>
      <clipPath id="clp237">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11594"
        />
      </clipPath>
      <clipPath id="clp241">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11621"
        />
      </clipPath>
      <clipPath id="clp240">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11615"
        />
      </clipPath>
      <clipPath id="clp244">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11642"
        />
      </clipPath>
      <clipPath id="clp243">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11636"
        />
      </clipPath>
      <clipPath id="clp253">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11705"
        />
      </clipPath>
      <clipPath id="clp252">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11699"
        />
      </clipPath>
      <clipPath id="clp256">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11726"
        />
      </clipPath>
      <clipPath id="clp255">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11720"
        />
      </clipPath>
      <clipPath id="clp259">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11747"
        />
      </clipPath>
      <clipPath id="clp258">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11741"
        />
      </clipPath>
      <clipPath id="clp262">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11768"
        />
      </clipPath>
      <clipPath id="clp261">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11762"
        />
      </clipPath>
      <clipPath id="clp265">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11789"
        />
      </clipPath>
      <clipPath id="clp264">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11783"
        />
      </clipPath>
      <clipPath id="clp268">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11810"
        />
      </clipPath>
      <clipPath id="clp267">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11804"
        />
      </clipPath>
      <clipPath id="clp271">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11831"
        />
      </clipPath>
      <clipPath id="clp270">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11825"
        />
      </clipPath>
      <clipPath id="clp274">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11852"
        />
      </clipPath>
      <clipPath id="clp273">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11846"
        />
      </clipPath>
      <clipPath id="clp277">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11873"
        />
      </clipPath>
      <clipPath id="clp276">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11867"
        />
      </clipPath>
      <clipPath id="clp280">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11894"
        />
      </clipPath>
      <clipPath id="clp279">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11888"
        />
      </clipPath>
      <clipPath id="clp283">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11915"
        />
      </clipPath>
      <clipPath id="clp282">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11909"
        />
      </clipPath>
      <clipPath id="clp286">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11936"
        />
      </clipPath>
      <clipPath id="clp285">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11930"
        />
      </clipPath>
      <clipPath id="clp289">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11957"
        />
      </clipPath>
      <clipPath id="clp288">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11951"
        />
      </clipPath>
      <clipPath id="clp292">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11978"
        />
      </clipPath>
      <clipPath id="clp291">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11972"
        />
      </clipPath>
      <clipPath id="clp295">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path11999"
        />
      </clipPath>
      <clipPath id="clp294">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path11993"
        />
      </clipPath>
      <clipPath id="clp298">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path12020"
        />
      </clipPath>
      <clipPath id="clp297">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path12014"
        />
      </clipPath>
      <clipPath id="clp301">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path12041"
        />
      </clipPath>
      <clipPath id="clp300">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path12035"
        />
      </clipPath>
      <clipPath id="clp304">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path12062"
        />
      </clipPath>
      <clipPath id="clp303">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path12056"
        />
      </clipPath>
      <clipPath id="clp307">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path12083"
        />
      </clipPath>
      <clipPath id="clp306">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path12077"
        />
      </clipPath>
      <clipPath id="clp310">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path12104"
        />
      </clipPath>
      <clipPath id="clp309">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path12098"
        />
      </clipPath>
      <clipPath id="clp313">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path12125"
        />
      </clipPath>
      <clipPath id="clp312">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path12119"
        />
      </clipPath>
      <clipPath id="clp316">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path12146"
        />
      </clipPath>
      <clipPath id="clp315">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path12140"
        />
      </clipPath>
      <clipPath id="clp319">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path12167"
        />
      </clipPath>
      <clipPath id="clp318">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path12161"
        />
      </clipPath>
      <clipPath id="clp322">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path12188"
        />
      </clipPath>
      <clipPath id="clp321">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path12182"
        />
      </clipPath>
      <clipPath id="clp325">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path12209"
        />
      </clipPath>
      <clipPath id="clp324">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path12203"
        />
      </clipPath>
      <clipPath id="clp328">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path12230"
        />
      </clipPath>
      <clipPath id="clp327">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path12224"
        />
      </clipPath>
      <clipPath id="clp331">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path12251"
        />
      </clipPath>
      <clipPath id="clp330">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path12245"
        />
      </clipPath>
      <clipPath id="clp334">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path12272"
        />
      </clipPath>
      <clipPath id="clp333">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path12266"
        />
      </clipPath>
      <clipPath id="clp337">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path12293"
        />
      </clipPath>
      <clipPath id="clp336">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path12287"
        />
      </clipPath>
      <clipPath id="clp340">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path12314"
        />
      </clipPath>
      <clipPath id="clp339">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path12308"
        />
      </clipPath>
      <clipPath id="clp343">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path12335"
        />
      </clipPath>
      <clipPath id="clp342">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path12329"
        />
      </clipPath>
      <clipPath id="clp346">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path12356"
        />
      </clipPath>
      <clipPath id="clp345">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path12350"
        />
      </clipPath>
      <clipPath id="clp349">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path12377"
        />
      </clipPath>
      <clipPath id="clp348">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path12371"
        />
      </clipPath>
      <clipPath id="clp352">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path12398"
        />
      </clipPath>
      <clipPath id="clp351">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path12392"
        />
      </clipPath>
      <clipPath id="clp355">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path12419"
        />
      </clipPath>
      <clipPath id="clp354">
        <path
          d="M -1,794 L 596,794 L 596,-2 L -1,-2 L -1,794 z "
          id="path12413"
        />
      </clipPath>

      <clipPath id="clipPath20771">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20773"
        />
      </clipPath>

      <clipPath id="clipPath20779">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20781"
        />
      </clipPath>

      <clipPath id="clipPath20787">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20789"
        />
      </clipPath>

      <clipPath id="clipPath20795">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20797"
        />
      </clipPath>

      <clipPath id="clipPath20803">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20805"
        />
      </clipPath>

      <clipPath id="clipPath20811">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20813"
        />
      </clipPath>

      <clipPath id="clipPath20819">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20821"
        />
      </clipPath>

      <clipPath id="clipPath20827">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20829"
        />
      </clipPath>

      <clipPath id="clipPath20835">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20837"
        />
      </clipPath>

      <clipPath id="clipPath20843">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20845"
        />
      </clipPath>

      <clipPath id="clipPath20851">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20853"
        />
      </clipPath>

      <clipPath id="clipPath20763">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20765"
        />
      </clipPath>

      <clipPath id="clipPath20755">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20757"
        />
      </clipPath>

      <clipPath id="clipPath20747">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20749"
        />
      </clipPath>

      <clipPath id="clipPath20739">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20741"
        />
      </clipPath>

      <clipPath id="clipPath20731">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20733"
        />
      </clipPath>

      <clipPath id="clipPath20723">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20725"
        />
      </clipPath>

      <clipPath id="clipPath20715">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20717"
        />
      </clipPath>

      <clipPath id="clipPath20707">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20709"
        />
      </clipPath>

      <clipPath id="clipPath20699">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20701"
        />
      </clipPath>

      <clipPath id="clipPath20691">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20693"
        />
      </clipPath>

      <clipPath id="clipPath20683">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20685"
        />
      </clipPath>

      <clipPath id="clipPath20675">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20677"
        />
      </clipPath>

      <clipPath id="clipPath20667">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20669"
        />
      </clipPath>

      <clipPath id="clipPath20659">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20661"
        />
      </clipPath>

      <clipPath id="clipPath20651">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20653"
        />
      </clipPath>

      <clipPath id="clipPath20643">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20645"
        />
      </clipPath>

      <clipPath id="clipPath20635">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20637"
        />
      </clipPath>

      <clipPath id="clipPath20627">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20629"
        />
      </clipPath>

      <clipPath id="clipPath20619">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20621"
        />
      </clipPath>

      <clipPath id="clipPath20611">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20613"
        />
      </clipPath>

      <clipPath id="clipPath20603">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20605"
        />
      </clipPath>

      <clipPath id="clipPath20595">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20597"
        />
      </clipPath>

      <clipPath id="clipPath20587">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20589"
        />
      </clipPath>

      <clipPath id="clipPath20579">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20581"
        />
      </clipPath>

      <clipPath id="clipPath20571">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20573"
        />
      </clipPath>

      <clipPath id="clipPath20563">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20565"
        />
      </clipPath>

      <clipPath id="clipPath20555">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20557"
        />
      </clipPath>

      <clipPath id="clipPath20547">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20549"
        />
      </clipPath>

      <clipPath id="clipPath20539">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20541"
        />
      </clipPath>

      <clipPath id="clipPath20531">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20533"
        />
      </clipPath>

      <clipPath id="clipPath20523">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20525"
        />
      </clipPath>

      <clipPath id="clipPath20515">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20517"
        />
      </clipPath>

      <clipPath id="clipPath20507">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20509"
        />
      </clipPath>

      <clipPath id="clipPath20499">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20501"
        />
      </clipPath>

      <clipPath id="clipPath20491">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20493"
        />
      </clipPath>

      <clipPath id="clipPath20483">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20485"
        />
      </clipPath>

      <clipPath id="clipPath20475">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20477"
        />
      </clipPath>

      <clipPath id="clipPath20467">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20469"
        />
      </clipPath>

      <clipPath id="clipPath20459">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20461"
        />
      </clipPath>

      <clipPath id="clipPath20451">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20453"
        />
      </clipPath>

      <clipPath id="clipPath20443">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20445"
        />
      </clipPath>

      <clipPath id="clipPath20435">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20437"
        />
      </clipPath>

      <clipPath id="clipPath20427">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20429"
        />
      </clipPath>

      <clipPath id="clipPath20419">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20421"
        />
      </clipPath>

      <clipPath id="clipPath20411">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20413"
        />
      </clipPath>

      <clipPath id="clipPath20403">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20405"
        />
      </clipPath>

      <clipPath id="clipPath20395">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20397"
        />
      </clipPath>

      <clipPath id="clipPath20387">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20389"
        />
      </clipPath>

      <clipPath id="clipPath20379">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20381"
        />
      </clipPath>

      <clipPath id="clipPath20371">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20373"
        />
      </clipPath>

      <clipPath id="clipPath20363">
        <path
          d="M 0.03,793.02 L 595.05,793.02 L 595.05,0 L 0.03,0 L 0.03,793.02 z "
          id="path20365"
        />
      </clipPath>
    </defs>
  </SvgIcon>
);

export default LillyLogo;
